import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'The anticipated response of change for a change impact',
    name: 'Change Impact Anticipated Response',
    partialId: PartialId.Standard.create('change_impact_anticipated_response'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
